import 'bridge'

import { umami_init_track } from './umami'

import Navbar from 'layout/navbar'
import {
    Component,
    createEffect,
    createMemo,
    createSignal,
    lazy,
    on,
    onCleanup,
    onMount,
    Show,
} from 'solid-js'

export const TEHRAN_CENTER_DEF = [51.33808559203892, 35.69973203736]

globalThis.USER_INVITE_KEY = 'ui'
globalThis.READ_CRIMES_POPUP = false
globalThis.NAV_TO_MAP = null
globalThis.LAST_SEARCH_LOC = null
globalThis.LAST_MAP_INFO = null
globalThis.MAP_INFO_BEFORE_SEARCHING = null
globalThis.DISCOUNT_COUNTDOWN_THRESHHOLD = 2
// if (!globalThis.GOOJE_NATIVE_RUNTIME) {
//     globalThis.GOOJE_NATIVE_RUNTIME = false
// }

let Home: any,
    News: any,
    Map: any,
    Account: any,
    Info: any,
    Notifs: any,
    MyFeedbacks: any,
    MyDiscounts: any,
    Reviews: any,
    Saved: any,
    Password: any,
    MyEateries: any,
    MyRequests: any,
    MyInvites: any,
    ContactUs: any,
    // MyTickets: any,
    Wallet: any,
    Suggestions: any,
    Crimes: any,
    Login: any,
    Popup: any,
    Welcomer: any,
    HomePicker: any,
    ForgotUrName: any,
    ShareUs: any,
    RateEatery: any,
    Rules: any,
    Privacy: any,
    VerifiedEateries: any

if (isServer) {
    ;(async () => {
        // must load first
        Welcomer = (await import('comps/welcomer')).default

        Home = (await import('pages/home')).default
        News = (await import('pages/news')).default
        Map = (await import('pages/map')).default
        Account = (await import('pages/account')).default
        Info = (await import('pages/account/info')).default
        Notifs = (await import('pages/account/notifs')).default
        MyFeedbacks = (await import('pages/account/myFeedbacks')).default
        MyDiscounts = (await import('pages/account/myDiscounts')).default
        Reviews = (await import('pages/account/reviews')).default
        Saved = (await import('pages/account/saved')).default
        Password = (await import('pages/account/password')).default
        MyEateries = (await import('pages/account/myEateries')).default
        MyRequests = (await import('pages/account/myRequests')).default
        MyInvites = (await import('pages/account/myInvites')).default
        ContactUs = (await import('pages/account/contactUs')).default
        // MyTickets = (await import('pages/account/myTickets')).default
        Wallet = (await import('pages/account/wallet')).default
        Suggestions = (await import('pages/account/suggestions')).default
        Crimes = (await import('pages/account/crimes')).default
        Login = (await import('pages/login')).default
        Popup = (await import('comps/popup')).default
        HomePicker = (await import('comps/homePicker')).default
        ForgotUrName = (await import('comps/forgotUrName')).default
        // ForgotUrBirthday = (await import('comps/forgotUrBirthday')).default
        ShareUs = (await import('comps/shareUs')).default
        RateEatery = (await import('comps/rateEatery')).default
        Rules = (await import('pages/rules')).default
        Privacy = (await import('pages/privacy')).default
        VerifiedEateries = (await import('pages/verifiedEateries')).default
    })().catch(err => {
        console.error(
            'Server import error:',
            err && err.stack ? err.stack : err
        )
        process.exit(1) // or handle gracefully
    })
} else {
    // must load first
    Welcomer = lazy(() => import('comps/welcomer'))

    Home = lazy(() => import('pages/home'))
    News = lazy(() => import('pages/news'))
    Map = lazy(() => import('pages/map'))
    Account = lazy(() => import('pages/account'))
    Info = lazy(() => import('pages/account/info'))
    Notifs = lazy(() => import('pages/account/notifs'))
    MyFeedbacks = lazy(() => import('pages/account/myFeedbacks'))
    MyDiscounts = lazy(() => import('pages/account/myDiscounts'))
    Reviews = lazy(() => import('pages/account/reviews'))
    Saved = lazy(() => import('pages/account/saved'))
    Password = lazy(() => import('pages/account/password'))
    MyEateries = lazy(() => import('pages/account/myEateries'))
    MyRequests = lazy(() => import('pages/account/myRequests'))
    MyInvites = lazy(() => import('pages/account/myInvites'))
    ContactUs = lazy(() => import('pages/account/contactUs'))
    // MyTickets = lazy(() => import('pages/account/myTickets'))
    Wallet = lazy(() => import('pages/account/wallet'))
    Suggestions = lazy(() => import('pages/account/suggestions'))
    Crimes = lazy(() => import('pages/account/crimes'))
    Login = lazy(() => import('pages/login'))
    Popup = lazy(() => import('comps/popup'))
    HomePicker = lazy(() => import('comps/homePicker'))
    ForgotUrName = lazy(() => import('comps/forgotUrName'))
    // ForgotUrBirthday = lazy(() => import('comps/forgotUrBirthday'))
    ShareUs = lazy(() => import('comps/shareUs'))
    RateEatery = lazy(() => import('comps/rateEatery'))
    Rules = lazy(() => import('pages/rules'))
    Privacy = lazy(() => import('pages/privacy'))
    VerifiedEateries = lazy(() => import('pages/verifiedEateries'))
}

import {
    // Navigate,
    Route,
    Router,
    RouteSectionProps,
    useLocation,
} from '@solidjs/router'
import LoadingPage from 'comps/loadingPage'
import { getDB } from 'db'
import { isAndroidOrOther, isIOS } from 'shared'
import { USER_READ_CRIMES_TIMESTAMP, USER_WELCOMED } from 'store/dbLabels'
import './style/base.scss'

import { Gene } from 'api'
import { native_is_notifications_enabled } from 'bridge'
import AddHome, { setShowAddHome } from 'comps/addHome'
import Alerts from 'comps/alert'
import { IsClient, IsMobile, WarningIfLandscape } from 'comps/helpers'
import UpdateNotif from 'comps/UpdateNotif'
import Page404 from 'pages/404/Page404'
import {
    loadSessionSummary,
    trackUserSessionSummary,
} from 'shared/umami-events'
import { createStore } from 'solid-js/store'
import { isServer } from 'solid-js/web'
import { app_state } from 'store/app'
import { locPickerState, self, update_user_notif_perm } from 'store/user'
import './style/pcmode.scss'
import './style/sp-emojies.css'
import './style/theme.scss'

export const EATERIES_VIEWED: Set<Gene> = new Set()

type AppProps = {
    page_loading?: boolean
    url?: string
}
export const App: Component<AppProps> = P => {
    onMount(() => {
        // Restore any summary accumulated during this browser session.
        loadSessionSummary()

        umami_init_track()
        try {
            if (umami) umami.track()
        } catch {}

        if ('serviceWorker' in navigator) {
            // Register from root scope
            navigator.serviceWorker
                .register('/sw.js')
                .then(registration => {
                    if (navigator.onLine) {
                        registration.update()
                    }
                })
                .catch(error => {
                    console.error('SW registration failed:', error)
                })
        }

        if (globalThis.GOOJE_BRIDGE) {
            setupNotifState()

            // push_notification({ title: 'hello from web-app' })
        }
    })

    onCleanup(() => {
        trackUserSessionSummary()
    })

    const setupNotifState = async () => {
        let notifStatus = await native_is_notifications_enabled()

        update_user_notif_perm(notifStatus)
    }

    return (
        <>
            <IsClient>
                <LoadingPage />
            </IsClient>

            <Router url={P.url} base='/' root={Rootlayout}>
                <Route path='/map/' component={Map}>
                    <Route path='e/:gene' />
                    <Route path='*' />
                </Route>

                <Route path={'/account/'} component={Account}>
                    <Route path={'info/'} component={Info} />
                    <Route path={'notifs/'} component={Notifs} />
                    <Route path={'password/'} component={Password} />
                    <Route path={'my-requests/'} component={MyRequests} />
                    <Route path={'contact-us/'} component={ContactUs} />
                    {/* <Route path={'my-tickets/'} component={MyTickets} /> */}
                    <Route path={'my-eateries/'} component={MyEateries} />
                    <Route path={'my-invites/'} component={MyInvites} />
                    <Route path={'my-feedbacks/'} component={MyFeedbacks} />
                    <Route path={'my-discounts/'} component={MyDiscounts} />
                    <Route path={'wallet/'} component={Wallet} />
                    <Route path={'reviews/'} component={Reviews} />
                    <Route path={'saved/'} component={Saved} />
                    <Route path={'suggestions/'} component={Suggestions} />
                    <Route path={'crimes/'} component={Crimes} />

                    <Route path={'*'} component={undefined} />
                </Route>

                <Route path={'/'} component={Home}></Route>
                <Route path={'/news'} component={News}></Route>

                <Route path={'/login'} component={Login} />

                <Route path={'/rules'} component={Rules} />
                <Route path={'/privacy'} component={Privacy} />
                <Route
                    path={'/verified-eateries'}
                    component={VerifiedEateries}
                />

                <Route path='*' component={Page404} />
            </Router>

            <Alerts />
        </>
    )
}
export default App

export const [welcome, setWelcome] = createSignal<boolean>(false)
export const [forceShowLogin, setForceShowLogin] = createSignal<boolean>(false)

const Rootlayout = (P: RouteSectionProps) => {
    const [deferredPrompt, setDeferredPrompt] = createSignal<any | null>(null)

    type State = {
        show_app_banner: boolean
        is_on_safari: boolean

        isServer: boolean
    }
    const [state, setState] = createStore<State>({
        show_app_banner: false,
        is_on_safari: false,

        isServer: true,
    })

    let loc = useLocation()

    const exeptionsUrls = ['/privacy', '/rules', '/verified-eateries']
    const isExceptionUrl = createMemo(() =>
        exeptionsUrls.includes(loc.pathname)
    )

    if (!isServer) {
        initWelcomer()
        initCrimesRead()
    }

    createEffect(
        on(
            () => {
                loc.pathname
                loc.hash
                loc.key
                loc.query
                loc.state
                loc.search
            },
            () => {
                try {
                    if (umami) umami.track()
                } catch {}
            }
        )
    )

    onMount(() => {
        setState('isServer', false)

        const onBeforeInstallPrompt = (e: Event) => {
            // @ts-ignore
            const evt = e as BeforeInstallPromptEvent
            evt.preventDefault()
            setDeferredPrompt(evt)

            requestAnimationFrame(() => {
                setShowAddHome(true)
            })
        }

        window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt)

        let isInWebAppiOS =
            /* @ts-ignore */
            'standalone' in window.navigator &&
            window.navigator.standalone === true

        let isInWebAppChrome = window.matchMedia(
            '(display-mode: standalone)'
        ).matches

        let isOnChrome = /Chrome/.test(navigator.userAgent)
        let isOnSafari =
            /Safari/.test(navigator.userAgent) &&
            !/Chrome/.test(navigator.userAgent)

        const iosManual = isIOS() && isOnSafari && !isInWebAppiOS
        const chromePrompt =
            isAndroidOrOther() &&
            isOnChrome &&
            !isInWebAppChrome &&
            !!deferredPrompt()

        setState({
            show_app_banner: iosManual || chromePrompt,
            is_on_safari: isOnSafari,
        })

        onCleanup(() => {
            window.removeEventListener(
                'beforeinstallprompt',
                onBeforeInstallPrompt
            )
        })
    })

    async function initWelcomer() {
        const parts = loc.pathname.split('/').filter(Boolean)
        const gene =
            parts[0] === 'map' && parts[1] === 'e' && parts[2] ? parts[2] : ''

        if (
            parts.includes('rules') ||
            parts.includes('verified-eateries') ||
            parts.includes('privacy')
        )
            return

        // const has_query = deepcopy(loc.query)

        // if (has_query) {
        //     const rawTheme =
        //         has_query && has_query.theme
        //             ? Array.isArray(has_query.theme)
        //                 ? has_query.theme[0]
        //                 : has_query.theme
        //             : ''

        //     if (rawTheme && is_eatery_theme(rawTheme)) {
        //         return
        //     }
        // }

        if (gene) return

        let timeStamp = await getDB(USER_WELCOMED)

        if (timeStamp) return

        setWelcome(true)
    }
    async function initCrimesRead() {
        let read_timestamp = localStorage.getItem(USER_READ_CRIMES_TIMESTAMP)

        globalThis.READ_CRIMES_POPUP = !!read_timestamp
    }

    return (
        <>
            <Show when={state.show_app_banner}>
                <AddHome
                    deferredPrompt={deferredPrompt()}
                    // pass a prop telling the component to show iOS instructions
                    //  when deferredPrompt is null
                    iosFallback={
                        app_state.is_ios &&
                        state.is_on_safari &&
                        !deferredPrompt()
                    }
                />
            </Show>

            <IsClient>
                <Show when={welcome()}>
                    <Welcomer />
                </Show>
            </IsClient>

            <Show
                when={!isExceptionUrl()}
                fallback={
                    <>
                        <Navbar />

                        {P.children}
                    </>
                }
            >
                <Show
                    when={
                        (self.user?.gene || state.isServer) && !forceShowLogin()
                    }
                    fallback={<Login />}
                >
                    <IsClient>
                        <ShareUs />

                        <RateEatery />

                        <ForgotUrName />
                        <UpdateNotif />
                        {/* <ForgotUrBirthday /> */}

                        <Popup />
                    </IsClient>

                    <IsMobile>
                        <WarningIfLandscape />
                    </IsMobile>

                    <Navbar />

                    {P.children}
                </Show>

                <Show when={locPickerState.show}>
                    <HomePicker />
                </Show>
            </Show>
        </>
    )
}
